var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3133 19.4546C15.7029 19.4546 19.2614 15.8961 19.2614 11.5065C19.2614 7.11694 15.7029 3.55847 11.3133 3.55847C6.9237 3.55847 3.36523 7.11694 3.36523 11.5065C3.36523 15.8961 6.9237 19.4546 11.3133 19.4546Z",
    stroke: "#C4C4C4",
    strokeWidth: 2.38442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2485 21.4416L16.9268 17.1199",
    stroke: "#C4C4C4",
    strokeWidth: 2.38442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.699dd1758f670be118a3cc407f5c5ed6.svg";
export { ForwardRef as ReactComponent };